import { ReactNode } from "react";

type Testimonial = {
    title: string;
    copy: ReactNode;
    author: string;
    avatarUrl: string;
    age: number;
};

export const TESTIMONIALS: Testimonial[] = [
    {
        title: "I feel like a horny teenager!",
        copy: (
            <>
                I’ve been completely checked out.
                Zero sex drive. I could tell it was messing with my husband’s confidence too.
                But let’s just say, we were worried our neighbors downstairs would think we are crazy. <br/>
                <br/>
                I forgot I had this fire in me.
            </>
        ),
        author: "Irene",
        avatarUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789486853/Testimonials/Irene_qmachk.webp",
        age: 45,
    },
    {
        title: "Best Sex Ever!",
        copy: "This has returned my spark literally and ignited the fire back in my life. I have been having the best, most intense orgasms I have ever had.",
        author: "Ingrid",
        avatarUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789486854/Testimonials/Ingrid_jkb0nf.webp",
        age: 48,
    },
    {
        title: "We almost got kicked out of the hotel room last night.",
        copy: "I was completely checked out. I genuinely forgot I had this fire in me. I thought that part of me was just gone. Give this a try.",
        author: "Rachel",
        avatarUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789486854/Testimonials/Rachel_jnp7ul.webp",
        age: 39,
    },
    {
        title: "I experience such a powerful connection with him.",
        copy: "I ordered this as a last ditch effort to revive our intimate life. We’ve been married 25 years. I have been taking Libida for 3 months and our intimate life has never been better. ",
        author: "Dianne",
        avatarUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789486853/Testimonials/Dianne_m6p3iy.webp",
        age: 52,
    },
];
